import { Body, Col, Row, Stack, SubHeading } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { TableEmptyStateContainer } from '../CMSAssetLocationsTable/CMSAssetLocationsTable.styles';

const { t } = I18n;

const TRANSLATED_EMPTY_TABLE_SUBHEADING = t('js.admin.cms.dashboard_table.verification_empty_description');
const TRANSLATED_EMPTY_TABLE_BODY = t('js.admin.cms.dashboard_table.verification_empty_title');

export const CMSDashboardVerificationEmptyState = () => (
  <TableEmptyStateContainer>
    <Stack size={6}>
      <Row>
        <Col>
          <Stack size={2}>
            <SubHeading level="md">{TRANSLATED_EMPTY_TABLE_SUBHEADING}</SubHeading>
            <Body level="md">{TRANSLATED_EMPTY_TABLE_BODY}</Body>
          </Stack>
        </Col>
      </Row>
    </Stack>
  </TableEmptyStateContainer>
);
